export default "<app-header></app-header>\n\n<div class=\"container-fluid\"> \n\t<router-outlet></router-outlet>\n</div>\n \n\n"